define("css", {
    _included: {},
    load: function(name, req, onload, config) {

        let path = name;
        if ( !/\.css$/.test(path) ) {
            path = path + ".css";
        }

        if ( this._included[path] ) {
            onload();
            return;
        }

        this._included[path] = true;

        // @see also /gulpfile.frontend.js  css2js()
        require([path], function(css) {

            const style = document.createElement("style");
            style.innerHTML = css;
            style.setAttribute("data-file-path", path);

            document.body.appendChild(style);
            onload();
        });
    }
});
